export default __webpack_public_path__ + "static/media/win-msvc-icon.ca282add.svg";